import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { helper } from 'src/environments/helper';
import { CereriService } from '../cereri.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UpdateMassStatusPayload } from '../cereri.interface';
import { StatusService } from 'src/app/platform/nomenclatoare/status-cerere/status.service';

@Component({
    selector: 'app-cereri-status',
    templateUrl: './cereri-status.component.html',
    styleUrls: ['./cereri-status.component.scss']
})
export class CereriStatusComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: 'Toate',
        id: '-1',
    };

    requestStatuses: any[] = this.data.statusCerere;

    form: FormGroup = new FormGroup({
        current_status: new FormControl('', [Validators.required]),
        message: new FormControl(''),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<CereriStatusComponent>,
        private cereriService: CereriService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;
        const ids_cerere = this.data.selectedRowIds;
        const currentStatusValue = this.form.get('current_status')?.value;
        const messageValue = this.form.get('message')?.value;

        const newStatus: UpdateMassStatusPayload = {
            ids_cerere,
            current_status: currentStatusValue,
            message: messageValue,
        };

        this.cereriService
            .updateMassStatus(newStatus)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
